import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import WeeklyShipService from './WeeklyShipService';
import { formatDate } from '../../utils/dateUtils';

// Read-only list of dealer parcels that were imported but did NOT physically arrive in their
// planned round ("ตกรอบ"). Kept deliberately separate from the HOLD-clear list so these locked
// boxes are never mistaken for unidentified holds. They re-enter a round automatically when the
// physical parcel is scanned at the station — there is no manual "clear into a round" here.
const NotArrivedItemsModal = ({ onClose }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [zoomUrl, setZoomUrl] = useState(null);

  useEffect(() => {
    WeeklyShipService.getNotArrivedBoxes()
      .then((r) => setItems(r.data))
      .catch(() => toast.error('โหลดรายการพัสดุยังไม่มาส่งไม่ได้'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-3xl max-h-[85vh] flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <h2 className="font-semibold text-gray-800">พัสดุยังไม่มาส่ง (ตกรอบ)</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-xl leading-none">×</button>
        </div>
        <div className="px-6 py-2 text-xs text-gray-400 border-b border-gray-100 bg-gray-50">
          นำเข้าแล้วแต่ยังไม่มาถึง — จะกลับเข้ารอบอัตโนมัติเมื่อสแกน QR ตอนของมาถึงจริง
        </div>

        <div className="flex-1 overflow-y-auto px-6 py-4">
          {loading && <p className="text-sm text-gray-400 text-center py-6">กำลังโหลด…</p>}
          {!loading && items.length === 0 && <p className="text-sm text-gray-300 text-center py-6">ไม่มีพัสดุตกรอบ</p>}
          {!loading && items.length > 0 && (
            <table className="w-full text-sm">
              <thead>
                <tr className="text-xs text-gray-400 uppercase border-b border-gray-100">
                  <th className="text-left py-2">Dealer #</th>
                  <th className="text-left py-2">รูป</th>
                  <th className="text-left py-2">รอบเดิม</th>
                  <th className="text-left py-2">ลูกค้า</th>
                  <th className="text-left py-2">Tracking JP</th>
                  <th className="text-right py-2">น้ำหนัก</th>
                </tr>
              </thead>
              <tbody>
                {items.map((it) => (
                  <tr key={it.uuid} className="border-b border-gray-50">
                    <td className="py-2 font-mono font-semibold text-amber-700">{it.dealerBoxNo}</td>
                    <td className="py-2">
                      {it.shipImageUrl && it.shipImageUrl.startsWith('http') ? (
                        <img src={it.shipImageUrl} alt="" onClick={() => setZoomUrl(it.shipImageUrl)} className="w-12 h-12 object-cover rounded border border-gray-200 cursor-zoom-in" />
                      ) : (
                        <span className="text-gray-300 text-xs">—</span>
                      )}
                    </td>
                    <td className="py-2 text-gray-600">{it.originShipDate ? formatDate(it.originShipDate) : '-'}</td>
                    <td className="py-2 text-gray-700">
                      {it.smileName || it.smileNameInput || <span className="text-gray-400 italic">ไม่ระบุ</span>}
                    </td>
                    <td className="py-2 font-mono text-gray-600">
                      {it.trackingJp || <span className="text-gray-400 italic">-</span>}
                    </td>
                    <td className="py-2 text-right text-gray-600">{it.weight != null ? `${it.weight} kg` : '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {zoomUrl && (
        <div className="fixed inset-0 bg-black/70 z-[60] flex items-center justify-center p-4" onClick={() => setZoomUrl(null)}>
          <img src={zoomUrl} alt="" className="max-w-full max-h-full rounded-lg" />
        </div>
      )}
    </div>
  );
};

export default NotArrivedItemsModal;
